var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content pt-4 flex flex-col items-center text-center"
  }, [_c('h1', [_vm._v("Assign your primary checking account")]), _vm._v(" "), _c('progress-indicator', {
    staticClass: "mt-6 mb-8",
    attrs: {
      "step": 3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col items-center gap-3 text-lg leading-6"
  }, [_vm.layout === 1 ? _c('p', [_vm._v("\n\t\t\t\tOnce connected, Extra will deduct* your daily purchases from your primary checking account\n\t\t\t\tat the end of each day. Link to your existing checking account and you can:\n\t\t\t")]) : _vm.layout === 2 ? _c('p', [_vm._v("\n\t\t\t\tExtra will debit* your primary checking account for purchases you make at the end of the\n\t\t\t\tday. By connecting your bank to Extra via Plaid, you can:\n\t\t\t")]) : _vm.layout === 3 ? _c('p', [_vm._v("\n\t\t\t\tLink your primary checking account, and your everyday purchases with the Extra Debit Card\n\t\t\t\tcan help you build your credit. Once connected, you can:\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "mt-3",
    attrs: {
      "src": require("@/assets/images/lock-green.svg"),
      "alt": "",
      "draggable": "false"
    }
  }), _vm._v(" "), _vm.layout === 1 ? _c('p', [_vm._v("\n\t\t\t\tKeep your current bank while building credit with the Extra Debit Card\n\t\t\t")]) : _vm.layout === 2 ? _c('p', [_vm._v("\n\t\t\t\tKeep your existing bank while building credit with Extra Debit Card\n\t\t\t")]) : _vm.layout === 3 ? _c('p', [_vm._v("\n\t\t\t\tMaintain your current bank while building credit with the Extra Debit Card.\n\t\t\t")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "mt-3",
    attrs: {
      "src": require("@/assets/images/union.svg"),
      "alt": "",
      "draggable": "false"
    }
  }), _vm._v(" "), _vm.layout === 1 ? _c('p', [_vm._v("\n\t\t\t\tAccess credit monitoring, account monitoring, and reward point perks\n\t\t\t")]) : _vm.layout === 2 || _vm.layout === 3 ? _c('p', [_vm._v("\n\t\t\t\tEnjoy Extra features such as credit reporting and reward points\n\t\t\t")]) : _vm._e()]), _vm._v(" "), _c('button', {
    staticClass: "button--filled mt-12 px-16 sm:w-full",
    class: {
      disabled: _vm.plaidProcessing
    },
    attrs: {
      "disabled": _vm.plaidProcessing,
      "data-cy": "open-plaid"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('continue');
      }
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.plaidProcessing ? 'Hold tight...' : 'Connect primary account') + "\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "mt-8 flex gap-6 items-center",
    class: {
      'flex-col': _vm.layout === 3
    }
  }, [_vm._m(0), _vm._v(" "), _vm.layout === 1 || _vm.layout === 2 ? _c('img', {
    attrs: {
      "src": require("@/assets/images/trustpilot.png"),
      "alt": "Trustpilot 4.5/5 Stars"
    }
  }) : _vm.layout === 3 ? _c('img', {
    attrs: {
      "src": require("@/assets/images/trustpilot-large.png"),
      "alt": "Trustpilot Great, 4.5/5 Stars, Based on 456 Reviews"
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "mt-8 text-sm text-gray-500"
  }, [_vm._v("\n\t\t\t*We may use information obtained via Plaid about your account balance in determining when to\n\t\t\tinitiate ACH debits transaction\n\t\t")])], 1)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('a', {
    staticClass: "ruhzbum",
    attrs: {
      "id": "bbblink",
      "href": "https://www.bbb.org/us/ca/los-angeles/profile/financial-services/extra-1216-1529537/#sealclick",
      "target": "_blank",
      "rel": "nofollow"
    }
  }, [_c('img', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://seal-sanjose.bbb.org/logo/ruhzbum/bbb-1529537.png",
      "alt": "EXTRA BBB Business Review"
    }
  })]);
}];
export { render, staticRenderFns };